import Button from 'components/UI/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './styles.module.scss';
import React from 'react';

import cn from 'classnames';
import Tabs from '../../components/UI/Tabs';
import PlannedRequests from './PlannedRequests';
import OpenSessions from './OpenSessions';
import ReportSessions from './ReportSessions';
import { useCashierOnlyStores, useSellerOnlyStores, useCleanerButtonVisible, useMyGigSellerStores, useMyGigCashierStores } from 'hooks/useStoreFilters';
import { useUnit } from 'effector-react';
import { $user } from 'models/user';
import { GroupsEnum } from 'types/users';

export default function Outsourcing() {
	const navigate = useNavigate();
	const user = useUnit($user);
	const isSellerOnlyStore = useSellerOnlyStores();
	const isCashierOnlyStore = useCashierOnlyStores();
	const showCleanerButton = useCleanerButtonVisible();
	const isMyGigSellerStore = useMyGigSellerStores();
	const isMyGigCashierStore = useMyGigCashierStores();

	const isMyShift = isSellerOnlyStore || isCashierOnlyStore;
	const isMyGig = isMyGigSellerStore || isMyGigCashierStore;

	const hasOutsourceRole = user?.groups?.some(group => group === GroupsEnum.OPENING_MANAGER);

	// Получаем активную вкладку из localStorage
	const getActiveTabFromStorage = () => {
		const savedTab = localStorage.getItem('outsourcing-active-tab');
		const validTabs = ['planned', 'open'];
		if (hasOutsourceRole) {
			validTabs.push('report');
		}
		return savedTab && validTabs.includes(savedTab) ? savedTab : 'planned';
	};

	const [activeTab, setActiveTab] = React.useState(getActiveTabFromStorage);

	// Обновляем активную вкладку при изменении роли пользователя
	React.useEffect(() => {
		const currentTab = getActiveTabFromStorage();
		setActiveTab(currentTab);
	}, [hasOutsourceRole]);

	// Сохраняем активную вкладку в localStorage при изменении
	const handleTabChange = (tabId: string) => {
		setActiveTab(tabId);
		localStorage.setItem('outsourcing-active-tab', tabId);
	};

	const tabs = [
		{
			id: 'planned',
			title: 'Плановые заявки на сегодня',
			content: (
				<>
					{!hasOutsourceRole && showCleanerButton && (
						<div className={cn(styles['section-item'], styles['section-item-top'])}>
							<Button variant="violet" onClick={() => navigate('add')}>
								Добавить исполнителя по уборке
							</Button>
						</div>
					)}
					<br />
				{isMyShift && (
					<div className={cn(styles['section-item'], styles['section-item-top'])}>
						<Button variant="violet" onClick={() => navigate('add?mode=myshift')}>
							Моя смена
						</Button>
					</div>
				)}
				{isMyGig && (
					<div className={cn(styles['section-item'], styles['section-item-top'])}>
						<Button variant="violet" onClick={() => navigate('add?mode=mygig')}>
							МАЙ ГИГ
						</Button>
					</div>
				)}
				<PlannedRequests />
				</>
			),
		},
		{
			id: 'open',
			title: 'Открытые смены',
			content: (
				<>
					{hasOutsourceRole && (
						<div className={cn(styles['section-item'], styles['section-item-top'])}>
							<Button variant="violet" onClick={() => navigate('add')}>
								Добавить исполнителя
							</Button>
						</div>
					)}
					<OpenSessions />
				</>
			),
		},
		// Добавляем вкладку отчетности только для ролей аутсорса
		...(hasOutsourceRole
			? [
					{
						id: 'report',
						title: 'Отчетность',
						content: <ReportSessions />,
					},
			  ]
			: []),
	];

	return (
		<div className={styles['section-list']}>
			<h2>Смены ИСИТ</h2>
			<Tabs tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
		</div>
	);
}
